var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"BackButton",on:{"click":function($event){return _vm.back()}}},[_vm._v(" "+_vm._s(_vm.$t('components.back-button.back'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }